<template>
  <nx-fullscreen-dialog
      :title="$t('message.block.textblock')"
      :active="active"
      @dismiss="dismiss">

    <template slot="toolbar-items">
      <v-btn
          color="accent"
          flat
          :disabled="!isValid"
          @click="insertBlot"
          v-html="buttonTitle"
      ></v-btn>
    </template>

    <v-container fluid pb-3>
      <v-layout>
        <v-flex offset-md2 md8 pt-4>
          <h2 class="nx-block-headline">{{ formTitle }}</h2>

          <nx-form>
            <component
              :is="'HTMLField'"
              name="html"
              :label="$t('message.form.fields.summary')"
              v-model="data.textblock"
              class="nx-primary--lighten-5 pt-3"
            ></component>
          </nx-form>

        </v-flex>
      </v-layout>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import DialogButton from './DialogButton';

export default {
  name: 'nx-textblock-button',
  extends: DialogButton,
  props: {
    embedTextblock: String,
  },
  data() {
    return {
      name: 'textblockEmbed',
      data: {
        textblock: this.embedTextblock || '',
      },
    };
  },
  computed: {
    isValid() {
      return this.data.textblock !== '';
    },
  },
};
</script>
